import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';

/**
 * Represents a link in the header component.
 *
 * @typedef {Object} HeaderLink
 *
 * @property {string} name - The display name of the link.
 * @property {string} href - The URL the link points to.
 * @property {string} [clickEventName] - Optional event name to be triggered on click.
 * @property {string} [tooltipText] - Optional text to be displayed in the tooltip.
 * @property {string} [tooltipPlace] - Optional position of the tooltip.
 * @property {string} [tooltipType] - Optional type of the tooltip.
 * @property {string} [tooltipTimer] - Optional timer for the tooltip display duration.
 */
export type HeaderLink = {
    name: string;
    href: string;
    clickEventName?: string;
    tooltipText?: string;
    tooltipPlace?: string;
    tooltipType?: string;
    tooltipTimer?: string;
};

/**
 * Represents a link with an icon in the header.
 *
 * @typedef {Object} HeaderIconLink
 * @property {string} icon - The name of the icon to be displayed.
 * @property {string} [iconFamily] - The family of the icon, if applicable.
 * @property {string} name - The name of the link.
 * @property {string} url - The URL the link points to.
 * @property {string} [clickEventName] - The name of the event to be triggered on click.
 * @property {string} [tooltipText] - The text to be displayed in the tooltip.
 * @property {string} [tooltipPlace] - The placement of the tooltip.
 * @property {string} [tooltipType] - The type of the tooltip.
 * @property {string} [tooltipTimer] - The timer for the tooltip.
 */
export type HeaderIconLink = {
    icon: string;
    iconFamily?: string;
    name: string;
    url: string;
    clickEventName?: string;
    tooltipText?: string;
    tooltipPlace?: string;
    tooltipType?: string;
    tooltipTimer?: string;
};

/**
 * Área de ações do cabeçalho: login, links e links com ícone.
 *
 * Componente de exibição (sem comportamento próprio) — apenas renderiza os
 * dados informados pelos inputs.
 */
@Component({
    selector: 'conversai-header-action',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './header-action.component.html',
})
export class HeaderAction {
    /** Indica se a opção de login está disponível. */
    hasLogin = input<boolean>(true);
    /** Rótulo do botão de login. */
    labelLogin = input<string>('Entrar');
    /** URL do avatar exibido na área de login. */
    imageAvatarLogin = input<string>('');
    /** Título da seção de links. */
    linksTitle = input<string>('Links');
    /** Lista de links do cabeçalho. */
    links = input<HeaderLink[]>([]);
    /** Título da seção de links com ícone. */
    iconLinksTitle = input<string>('Funções');
    /** Lista de links com ícone. */
    iconLinks = input<HeaderIconLink[]>([]);
}
